
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { add, tryFind, fold, ofList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { length, append, empty, isEmpty, choose, filter, sortBy, mapIndexed, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { DnDFormImage } from "./Image/ImageUploadDnD.js";
import { compare } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { compareArrays, arrayHash, equalArrays, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ImageRole } from "../Shared/AssignmentNotification.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export function whenOpen(isOpen, state, cmd) {
    return [state, isOpen ? cmd : Cmd_none()];
}

export function receiverFilesByEntity(detail) {
    return ofList(map((tupledArg) => [tupledArg[0], mapIndexed((index, image_3) => (new DnDFormImage(1, [{
        ImageUrl: image_3.ImageUrl,
        Position: index + 1,
    }])), sortBy((image_2) => image_2.UploadedAt, tupledArg[1], {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }))], List_groupBy((image_1) => [image_1.EntityType, image_1.EntityId], filter((image) => equals(image.Role, new ImageRole(1, [])), detail.Images), {
        Equals: equalArrays,
        GetHashCode: (x) => (arrayHash(x) | 0),
    })), {
        Compare: (x_2, y_2) => (compareArrays(x_2, y_2) | 0),
    });
}

export function withPendingUploads(current, fromServer) {
    return fold((merged, entityKey, files) => {
        const pendingFiles = choose((file) => {
            if (file.tag === 1) {
                return undefined;
            }
            else {
                return file.fields[0].File;
            }
        }, files);
        if (isEmpty(pendingFiles)) {
            return merged;
        }
        else {
            const serverFiles = defaultArg(tryFind(entityKey, merged), empty());
            return add(entityKey, append(serverFiles, mapIndexed((index, file_1) => (new DnDFormImage(0, [{
                File: file_1,
                Position: (length(serverFiles) + index) + 1,
            }])), pendingFiles)), merged);
        }
    }, fromServer, current);
}

